






















































































































































































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import Purchase from "../../../usecases/orders/purchase";
import PurchaseItemModel from "../../../usecases/orders/purchase-item";
import PurchaseItem from "../components/PurchaseItem.vue";
import PurchaseHeader from "../components/PurchaseHeader.vue";
import VToolbar from "../../common/components/VToolbar.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import PurchaseService from "@/usecases/orders/purchase-service";
import PurchaseApi from "../../../api/orders/purchase-api";
import { client } from "@/api/request";
import PurchaseStatus from "@/usecases/orders/purchase-status";
import PurchaseStatusTranslater from "@/usecases/orders/purchase-status-translater";
import UnitApi from "@/orders/api/unit-api";
import UnitOption from "../presenters/unit-option";
import PrintApi from "../../../api/orders/print-api";
import SubmitButton from "@/components/SubmitButton.vue";
import TextTemplateModal from "@/views/TextTemplateModal.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";
import uuid from "uuid";
import isDateBeforeServiceCreated from "@/helpers/isDateBeforeServiceCreated";
import InputReadOnlyWithButton from "../components/InputReadOnlyWithButton.vue";
import Status from "@/usecases/orders/purchase-status";
import PurchaseVendorModal from "../components/PurchaseVendorModal.vue";
import { IVendor } from "@/api/corp-api";
import BillingRuleApi from "@/orders/api/billing-rule-api";
import BillingRule from "@/orders/entities/billing-rule";
import parseDate from "@/helpers/parseDate";
import { isValid } from "date-fns";
import formatDate from "@/helpers/formatDate";

const printApi = new PrintApi(client);
const purchaseApi = new PurchaseApi(client);
const unitApi = new UnitApi(client);
const service = new PurchaseService(purchaseApi);
const billingRuleApi = new BillingRuleApi(client);

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    TextTemplateModal,
    VToolbar,
    PurchaseHeader,
    PurchaseItem,
    SubmitButton,
    LoadingButton,
    InputReadOnlyWithButton,
    PurchaseVendorModal
  }
})
export default class EditPurchasePage extends Vue {
  @Prop({ required: true }) id!: string;
  readonly Status = Status;
  textTemplateModalOpen = false;
  printing: boolean = false;
  purchase = new Purchase();
  vendorOptions: SelectOption[] = [];
  unitOptions: SelectOption[] = [];
  oldStatus: string = "";
  currentIndex: Set<number> = new Set<number>();
  billingRule: BillingRule = new BillingRule(0, 0, 0);
  billingRuleOriginal: BillingRule = new BillingRule(0, 0, 0);

  get statusOptions() {
    const options = PurchaseStatus.all().map(value => ({
      value,
      text: PurchaseStatusTranslater.toJp(value)
    }));

    if (this.purchase.status === Status.ACTUAL_RESULT) {
      options.push({
        value: Status.ACTUAL_RESULT,
        text: PurchaseStatusTranslater.toJp(Status.ACTUAL_RESULT)
      });
    }

    return options;
  }

  status: "" | "progressing" = "";

  async save() {
    this.status = "progressing";
    try {
      if (
        !isDateBeforeServiceCreated(
          this.purchase.dateOfIssue,
          this.$store.state.service.createdDate
        )
      ) {
        return;
      }
      await purchaseApi.save(this.purchase);
      await this.initPurchase();
      await this.$store.dispatch("setProjectEstimateExpenseSummary");
      alert("保存しました。");
    } catch (error) {
      alert("保存に失敗しました。");
    } finally {
      this.status = "";
    }
  }

  async destroy() {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await purchaseApi.destroy(Number(this.id));
    await this.$store.dispatch("setProjectEstimateExpenseSummary");
    this.goListPage();
  }

  goListPage() {
    this.$router.push({
      name: "order-purchase"
    });
  }

  calculate() {
    this.purchase = service.calculate(this.purchase);
  }

  protected async created() {
    await this.initPurchase();
    await this.initUnitList();
    await this.getBillingRule();
  }

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (!this.printing) {
      this.printing = true;
      try {
        const url = await printApi.getPurchasePrint(
          id,
          this.$store.state.accessToken,
          printsExcludeTax
        );
        window.open(url, "発注書印刷");
      } catch (e) {
        alert("印刷に失敗しました。しばらく待って改めてお試しください。");
      } finally {
        this.printing = false;
      }
    } else {
      alert("印刷中です");
    }
  }

  private async initPurchase() {
    this.purchase = await service.find(this.id);
    this.oldStatus = this.purchase.status;
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  addTextToMention(text: string) {
    if (this.purchase.mention) {
      this.purchase.mention += "\n";
    }
    this.purchase.mention += text;
    if (text.length > 0 && this.purchase.mention.length > 100) {
      this.purchase.mention = this.purchase.mention.slice(0, 100);
    }
    this.textTemplateModalOpen = false;
  }

  createDiscountRow(items: PurchaseItemModel[]) {
    let newItem = new PurchaseItemModel();
    newItem.id = uuid();
    newItem.estimateItemId = "";
    items.push(newItem);
    this.calculate();
  }

  removeDiscountRow(items: PurchaseItemModel[], item: PurchaseItemModel) {
    const index = items.findIndex(i => i.id === item.id);
    if (index > 0) {
      items.splice(index, 1);
      this.calculate();
    }
  }

  isNegative(value: number): boolean {
    return value < 0;
  }

  get disabledChangeStatus(): boolean {
    return this.oldStatus === PurchaseStatus.Invalid;
  }

  resetIndex() {
    this.currentIndex.clear();
    this.currentIndex.add(0);
  }

  getNextIndex(): number {
    const firstElement = this.currentIndex.values().next().value;
    this.currentIndex.clear();
    this.currentIndex.add(firstElement + 1);
    return firstElement;
  }

  get isStatusActualResult(): boolean {
    return this.purchase.status === Status.ACTUAL_RESULT;
  }

  showModal() {
    (this.$refs.vendorModal as any).showModal();
  }

  selectedVendor(value: IVendor) {
    this.purchase = {
      ...this.purchase,
      vendorId: value.vendorId,
      vendorName: value.vendorName
    };
  }

  private async getBillingRule() {
    this.billingRule = await billingRuleApi.findByProject(
      String(this.purchase.projectId),
      1
    );
  }

  private async getBillingRuleOriginal() {
    this.billingRuleOriginal = await billingRuleApi.findByProject(
      String(this.purchase.projectId),
      1,
      true
    );
  }

  async updateIssueAt(value: string) {
    let dateOfIssue = parseDate(value);
    if (!isValid(dateOfIssue)) {
      dateOfIssue = new Date();
    }
    await this.getBillingRuleOriginal();
    if (
      this.billingRuleOriginal.getDayOfMonth() == null ||
      this.billingRuleOriginal.getCutoffDate() == null ||
      this.billingRuleOriginal.getMonths() == null
    ) {
      this.purchase.issuedAt = "0000-00-00";
      return;
    }

    this.purchase.issuedAt = formatDate(
      this.billingRule.getDueDate(dateOfIssue)
    );
  }
}
